// extracted by mini-css-extract-plugin
export default {"userMenu__wrapper":"UserMenu_userMenu__wrapper__k7qSB","userMenu__text":"UserMenu_userMenu__text__IqC8v","userMenu__btn":"UserMenu_userMenu__btn__7Kj4v"};